import { render, staticRenderFns } from "./popovers.vue?vue&type=template&id=3145d573&"
import script from "./popovers.vue?vue&type=script&lang=js&"
export * from "./popovers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports